import { useMutation } from "@apollo/client";
import { evictFields } from "../../../helpers/cache";
import { REMOVE_PROSPECTION } from "../prospection.queries";
import {
  RemoveProspectionMutation,
  RemoveProspectionMutationVariables,
} from "../../../__generated__/RemoveProspectionMutation";

export const useRemoveProspection = () => {
  return useMutation<RemoveProspectionMutation, RemoveProspectionMutationVariables>(
    REMOVE_PROSPECTION,
    {
      refetchQueries: ["ProspectionsQuery"],
      update(cache) {
        evictFields(cache, ["prospection", "prospections"]);
      },
    }
  );
};
